import React, {useEffect} from "react";
import { Col, Container, Row, Form, Tab, Tabs } from "react-bootstrap";
import style from "../form.module.scss";
import { useKPIs } from "../../../context/KPIsContext";
import { TODIS_FORM_FIELD } from "../../../components/Forms";
import "react-datepicker/dist/react-datepicker.css";

const RAILWAYS_BORDER_CROSSING_NPM_KPI = ({data, changeValues}) => {

    const { setValues, values, calculoPromedio, calculoYesNo, calculoPerType } = useKPIs();

    useEffect(() => {
        setValues(prev => {
            return data
        })
    }, [data])

    useEffect(() => {
        calculateKPI()
    }, [values])

    const calculateKPI = () => {

        const datas = {
            infrastructure: {
                onStopProc: {  // TODO: CONSULTAR VALORES PARA FILTRAR
                    passengers: calculoPerType('one_stop_procedure_type', 'for passengers'),
                    goods: calculoPerType('one_stop_procedure_type', 'for goods'),
                    oneParty: calculoPerType('one_stop_procedure_type', 'collocated on the territory of one party'),
                    jointControls: calculoPerType('one_stop_procedure_type', 'entry-entry joint controls')
                },
                eqms: calculoYesNo('eqms'),
                other_electronic_is: calculoYesNo('other_electronic_is'),
                upgratingReq: {
                    req_upgrade_inc_capacity: calculoPromedio('req_upgrade_inc_capacity'),
                    req_upgrade_its: calculoPromedio('req_upgrade_its')
                },
            },
            operations: {
                control_type_phytosanitary: calculoPromedio('control_type_phytosanitary'),
                control_type_veterinary: calculoPromedio('control_type_veterinary'),
                control_type_radiological: calculoPromedio('control_type_radiological'),
                control_type_other: calculoPromedio('control_type_other')
            }
        }

        changeValues(datas)
    }
    
    return (
        <Tabs defaultActiveKey="Infrastructure" id="uncontrolled-tab-example" className="mb-3 todis-form-tabs-wrapper p-1 mt-3">
            <Tab eventKey="Infrastructure" title="Infrastructure" className={style.tabHeight}>
                <Container>
                    <Row>
                        <Col lg={12}>
                            <div style={{borderBottom: "3px solid #004494"}}>
                                <Form.Label style={{color: '#004494', fontSize: "16px", fontWeight: "bold"}}>One-stop procedure (Joint Border)</Form.Label>
                            </div>
                            <Row style={{paddingTop: "15px"}}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.onStopProc.passengers" label="% of joint BCP for passengers" name="infrastructure.onStopProc.passengers" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.onStopProc.goods" label="% of joint BCP for goods" name="infrastructure.onStopProc.goods" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.onStopProc.oneParty" label="% of joint BCP collocated on the territory of one party" name="infrastructure.onStopProc.oneParty" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.onStopProc.jointControls" label="% entry-entry joint controls" name="infrastructure.onStopProc.jointControls" disabled={true}/>
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="infrastructure.eqms" label="% eQMS" name="infrastructure.eqms" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="infrastructure.other_electronic_is" label="% Other electronic information system" name="infrastructure.other_electronic_is" disabled={true}/>
                        </Col>
                        <Col lg={12}>
                            <div style={{borderBottom: "3px solid #004494"}}>
                                <Form.Label style={{color: '#004494', fontSize: "16px", fontWeight: "bold"}}>Upgrade Requirements</Form.Label>
                            </div>
                            <Row style={{paddingTop: "15px"}}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.upgratingReq.req_upgrade_inc_capacity" label="% requiring upgrade to increase capacity (building infrastructure)" name="infrastructure.upgratingReq.req_upgrade_inc_capacity" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.upgratingReq.req_upgrade_its" label="% requiring upgrade to ITS" name="infrastructure.upgratingReq.req_upgrade_its" disabled={true}/>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="Operations" title="Operations" className={style.tabHeight}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="operations.control_type_phytosanitary" label="% Type of Controls with phytosanitary controls" name="operations.control_type_phytosanitary" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="operations.control_type_veterinary" label="% Type of Controls with veterinary controls" name="operations.control_type_veterinary" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="operations.control_type_radiological" label="% Type of Controls with radiological controls" name="operations.control_type_radiological" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="operations.control_type_other" label="% Type of Controls with other non-trade related controls" name="operations.control_type_other" disabled={true}/>
                        </Col>
                    </Row>
                </Container>
            </Tab>
        </Tabs>
    )
}

export default RAILWAYS_BORDER_CROSSING_NPM_KPI;